module.exports = __webpack_public_path__ + "img/upload_resource_file.907eb82f.svg";